import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'Carlos R.',
  city: 'CDMX'
}, {
  name: 'Ana P.',
  city: 'Bogotá'
}, {
  name: 'Roberto M.',
  city: 'Lima'
}, {
  name: 'Carmen R.',
  city: 'Lima'
}, {
  name: 'Luis T.',
  city: 'Santiago'
}, {
  name: 'Patricia M.',
  city: 'Madrid'
}, {
  name: 'Miguel A.',
  city: 'Monterrey'
}, {
  name: 'Valentina H.',
  city: 'Medellín'
}, {
  name: 'Andrés F.',
  city: 'Bogotá'
}, {
  name: 'Gabriela L.',
  city: 'Quito'
}, {
  name: 'Andrea C.',
  city: 'Caracas'
}, {
  name: 'Mariana D.',
  city: 'Puebla'
}, {
  name: 'Lucía B.',
  city: 'Córdoba'
}, {
  name: 'Elena K.',
  city: 'Cancún'
}, {
  name: 'Rosa N.',
  city: 'Barranquilla'
}];
export function PurchasePopup() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    const showNext = () => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 3500);
      index = (index + 1) % buyers.length;
    };
    // First popup after 15 seconds
    const initialTimeout = setTimeout(() => {
      showNext();
      // Then every 15 seconds
      const interval = setInterval(showNext, 15000);
      return () => clearInterval(interval);
    }, 15000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const buyer = current !== null ? buyers[current] : null;
  return <AnimatePresence data-id="element-353">
      {visible && buyer && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-20 left-4 z-40 bg-white rounded-lg shadow-lg border border-slate-200 px-4 py-3 flex items-center gap-3 max-w-[280px]" data-id="element-354">
          <div className="w-8 h-8 bg-brand-indigo/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-355">
            <ShoppingBag size={14} className="text-brand-indigo" data-id="element-356" />
          </div>
          <div className="min-w-0" data-id="element-357">
            <p className="text-xs font-semibold text-slate-800 truncate" data-id="element-358">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-[11px] text-slate-500" data-id="element-359">
              acaba de comprar APAGA LA MENTE
            </p>
          </div>
          <div className="w-1.5 h-1.5 bg-brand-indigo rounded-full animate-pulse flex-shrink-0" data-id="element-360" />
        </motion.div>}
    </AnimatePresence>;
}